<div id="credit-payment-method-container" class="container">
  <h2 *ngIf="payment_method_model.id">Update a Payment Account</h2>
  <h2 *ngIf="!payment_method_model.id">Add a Payment Account</h2>

  <div class="row">
    <div class="col-md-3 col-sm-4">
      <app-payments-menu></app-payments-menu>
    </div>
    <div class="col-md-9 col-sm-8">
      <div class="row">
        <div class="col-md-6">
          <mat-card appearance="outlined">
            <form [formGroup]="form" (ngSubmit)="submit()">
              <mat-card-title *ngIf="!payment_method_model.id">Add Card</mat-card-title>
              <mat-card-title *ngIf="payment_method_model.id">Edit Card</mat-card-title>
              <mat-card-subtitle>
                A $2.95 verification transaction will be performed to validate your payment method.
                This transaction is temporary and will not be billed to your account, and the funds will be released in
                24 hours.
              </mat-card-subtitle>
              <mat-card-content>
                <div class="cc-icon">
                  <fa-icon [icon]="faCcMastercard"></fa-icon>
                  <fa-icon [icon]="faCcDiscover"></fa-icon>
                  <fa-icon [icon]="faCcVisa"></fa-icon>
                </div>
                <div class="input-cell">
                  <mat-form-field>
                    <mat-label>Name on Card</mat-label>
                    <input matInput type="text" formControlName="cc_name_on_card" />
                  </mat-form-field>
                </div>
                <div class="row">
                  <div class="col-7 input-cell">
                    <mat-form-field>
                      <mat-label>Card Number</mat-label>
                      <input matInput type="text" formControlName="cc_number_mask" [mask]="edit ? '0000-0000-0000-0000' : ''" />
                    </mat-form-field>
                  </div>
                  <div class="col-1 input-cell">
                    <div class="cc-icon-lock">
                      <fa-icon [icon]="faLock"></fa-icon>
                    </div>
                  </div>
                  <div class="col-4 input-cell">
                    <mat-form-field>
                      <mat-label>CVV</mat-label>
                      <input matInput type="text" formControlName="cc_card_code"
                             mask="999" />
                    </mat-form-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6 input-cell">
                    <mat-form-field>
                      <mat-label>Exp. Month</mat-label>
                      <mat-select formControlName="cc_exp_month">
                        <mat-option *ngFor="let month of months" [value]="month.numeric">
                          {{ month.name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-6 input-cell">
                    <mat-form-field>
                      <mat-label>Exp. Year</mat-label>
                      <mat-select formControlName="cc_exp_year">
                        <mat-option *ngFor="let year of years" [value]="year.name">
                          {{ year.name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col-8 input-cell">
                    <mat-form-field>
                      <mat-label>Street Address</mat-label>
                      <input matInput type="text" formControlName="cc_street" />
                    </mat-form-field>
                  </div>
                  <div class="col-4 input-cell">
                    <mat-form-field>
                      <mat-label>Zip</mat-label>
                      <input matInput type="text" formControlName="cc_zip"
                             mask="00000" />
                    </mat-form-field>
                  </div>
                </div>              
              </mat-card-content>
              <div *ngIf="payment_information_acceptance" style="color:#999999;font-weight:normal;"><i [innerHTML]="payment_information_acceptance"></i></div>
              <div class="input-cell d-flex justify-content-center" *ngIf="!payment_method_model.id">
                <div>
                  <mat-slide-toggle formControlName="default_account" color="primary" class="mat-toggle" [checked]="true" [disabled]="!form.valid || first_payment_method">
                    Set as primary payment method
                  </mat-slide-toggle>                  
                </div>
              </div>
              <mat-card-actions class="mb-0">                
                <nexus-form-result [model]="result_model"></nexus-form-result>
                <p class="mb-0"><button mat-raised-button type="submit" [disabled]="!form.valid" color="primary">Save</button></p>
              </mat-card-actions>
            </form>
          </mat-card>
        </div>
        <div class="col-md-6">
          <module-payment-method-primary [payment_methods_model]="payment_methods_model" [payment_method_model]="payment_method_model" (primaryPaymentMethodSelected)="onPrimaryPaymentMethodSelected($event)"></module-payment-method-primary>   
          <app-payment-method-delete [payment_methods_model]="payment_methods_model" [payment_method_model]="payment_method_model" [regulatory_model]="regulatory_model"></app-payment-method-delete>        
          <payment-method-instructions></payment-method-instructions>
        </div>
      </div>
    </div>
  </div>
</div>
